export default __webpack_public_path__ + "static/media/vector_logo2.72f57525.png";